import { outcomeCounts } from "@/lib/integrations/words";

import { TONE_FILL } from "./HealthPill";
import styles from "./integrations.module.css";

/**
 * One bar split by row outcomes, with the words and counts under it.
 *
 * The legend is the real carrier: a colour on its own is never the answer.
 * With `onPick`, each word opens that outcome's rows.
 */
export function OutcomeBar({
  counts,
  small = false,
  legend = true,
  onPick,
  label,
}: {
  counts: Record<string, number>;
  small?: boolean;
  legend?: boolean;
  onPick?: (outcome: string) => void;
  label?: string;
}) {
  const parts = outcomeCounts(counts);
  const total = parts.reduce((sum, part) => sum + part.count, 0);
  const said = parts.map((part) => `${part.word} ${part.count.toLocaleString()}`).join(" · ");
  return (
    <div>
      <div
        className={small ? `${styles.bar} ${styles.barSmall}` : styles.bar}
        role="img"
        aria-label={`${label ?? `${total.toLocaleString()} rows`}: ${said || "no rows"}`}
        title={said || "No rows"}
      >
        {parts.map((part) => (
          <span
            key={part.key}
            className={`${styles.barPart} ${TONE_FILL[part.tone]}`}
            style={{ width: `${(part.count / Math.max(total, 1)) * 100}%` }}
          />
        ))}
      </div>
      {legend && (
        <div className={styles.legend}>
          {label && <span>{label}</span>}
          {parts.length === 0 && <span>No rows</span>}
          {parts.map((part) =>
            onPick ? (
              <button key={part.key} type="button" className={styles.legendItem} onClick={() => onPick(part.key)}>
                <span className={`${styles.swatch} ${TONE_FILL[part.tone]}`} aria-hidden />
                {part.word} {part.count.toLocaleString()}
              </button>
            ) : (
              <span key={part.key} className={styles.legendItem}>
                <span className={`${styles.swatch} ${TONE_FILL[part.tone]}`} aria-hidden />
                {part.word} {part.count.toLocaleString()}
              </span>
            ),
          )}
        </div>
      )}
    </div>
  );
}
